import { type OverrideType, type ValueBasedOverrideResponse } from 'domains/products/api'

export interface AttributeOverrideState {
  attribute: string
  sourceType: string
  overrideType: OverrideType
  isPermanent: boolean
  expiryDate: string
  comment: string
  ticketEntry: string
  value: string
  newValue: string
  permanentAcknowledgement: boolean
}

export interface AttributeOverride {
  expiryDate: string
  ticketUrl: string
  overrideType: OverrideType
  createdWhy: string
  sourceType: string
  attributeName: string
  sourceValue: string
  overrideValue: string
  username: string
}

export type AttributeType = 'boolean' | 'text' | 'bigtext'

export interface Attribute {
  name: string
  displayName: string
  type: AttributeType
  showInEdit: boolean
}

export const sourceTypeAllSources = 'all_sources'

export interface ValueBasedOverride
  extends Omit<ValueBasedOverrideResponse, 'rowId' | 'entityId' | 'createdByJson' | 'createdAt'> {
  username: string
}
